import React from 'react';
import PropTypes from 'prop-types';
import CalHeatMap from 'cal-heatmap';

import 'cal-heatmap/cal-heatmap.css';
import styles from './index.module.scss';

class DictationHeatMap extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: this.props.data,
      start: this.startDate(),
      end: this.endDate()
    };

    this.currentYear = this.currentYear.bind(this);
    this.startDate = this.startDate.bind(this);
    this.endDate = this.endDate.bind(this);
    this.monthNames = this.monthNames.bind(this);
    this.countWeeksBetweenTwoDates = this.countWeeksBetweenTwoDates.bind(this);
  }

  endDate = () => new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 7)
  startDate = () => new Date(new Date().getFullYear(), new Date().getMonth() - 9, new Date().getDate())
  currentYear = () => new Date().getFullYear()
  monthNames = () => ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"];
  countWeeksBetweenTwoDates(date_end, date_start) {
    var diff =(date_end.getTime() - date_start.getTime()) / 1000;
    diff /= (60 * 60 * 24 * 7);
    return Math.abs(Math.round(diff));
  }

  componentDidMount () {
    let cal = new CalHeatMap();
    let currentMonth = this.state.start.getMonth() - 1;

    cal.init({
      start: this.state.start,
      domain: "week",
      subDomain: "day",
      cellSize: 30,
      range: this.countWeeksBetweenTwoDates(this.state.end, this.state.start),
      rowLimit: 7,
      subDomainTextFormat: "%d",
      tooltip: true,
      maxDate: new Date(),
      domainGutter: 0,
      cellPadding: 1,
      cellRadius: 4,
      itemName: ["%", "%"],
      label: {
        position: "top"
      },
      legend: [50, 75, 90, 95, 98, 99.99],
      legendTitleFormat: {
        lower:	"moins que {min} {name}",
        inner:	"entre {down} et {up} {name}",
        upper:	"plus que {max} {name}"
      },
      data: `/users/${this.props.user_id}/contributions?start=${this.state.start.toISOString().split('T')[0]}&stop=${this.state.end.toISOString().split('T')[0]}`,
      domainLabelFormat: date => { //x-axis labels
        if (date.getMonth() == currentMonth)
            return "";

        //reset the current month
        currentMonth = date.getMonth();

        //return the label
        return this.monthNames()[date.getMonth()];
      },
      subDomainDateFormat: date => {
        return date.toLocaleDateString('fr-Fr', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
      },
      subDomainTitleFormat: {
        filled: "{count} {name} le {date}"
      },
      onComplete: () => {
        twemoji.parse(document.body, {
          base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@latest/assets/',
          folder: 'svg',
          ext: '.svg'
        });
      }
    });
  }

  render() {
    return (
      <div>
        <svg className="absolute opacity-0">
          <defs>
            <pattern id="diagonalHatch" patternUnits="userSpaceOnUse" width="4" height="4">
              <path d="M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2" style={{ stroke: "#e0eaec", strokeWidth: 1 }} />
            </pattern>
          </defs>
        </svg>
        <div className={styles.group} id="cal-heatmap">
          <div id="cal-heatmap-yaxislabels">
            <div className="graph-label">Lu</div>
            <div className="graph-label">Mer</div>
            <div className="graph-label">Ven</div>
            <div className="graph-label">Dim</div>
          </div>
        </div>
      </div>
    );
  }
}

DictationHeatMap.propTypes = {
  user_id: PropTypes.number,
};

DictationHeatMap.defaultProps = {
  data: []
};

export default DictationHeatMap;
